import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AlertModule } from 'ngx-bootstrap/alert';
//import { NgSelectModule } from '@ng-select/ng-select';
import { MatTabsModule } from '@angular/material/tabs';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { SharedUIModule } from './../shared/shared-ui.module';
import { UserManagementRoutes } from './user-management.routes';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AuditTrailComponent } from './audit-trail/audit-trail.component';
import { CommonService } from 'src/app/core/services/common/common.service';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { ManageRolesComponent } from './manage-roles/manage-roles.component';
import { UserManagerComponent } from './user-manager/user-manager.component';
import { CreateUsersComponent } from './create-users/create-users.component';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { AddRoleDialogComponent } from './add-role-dialog/add-role-dialog.component';
import { ManagePubTypeComponent } from './manage-pub-type/manage-pub-type.component';
import { ManagePlanTypeComponent } from './manage-plan-type/manage-plan-type.component';
import { DistributedUIModule } from './../distributed-ui-components/distributed-ui.module';
import { FileUploadDialogComponent } from './file-upload-dialog/file-upload-dialog.component';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { UserRegulatorDialogComponent } from './user-regulator-dialog/user-regulator-dialog.component';
import { UserManagementLandingComponent } from './user-management-landing/user-management-landing.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatInputModule } from '@angular/material/input';
import { ImpactAssessmentSettingsComponent } from './impact-assessment-settings/impact-assessment-settings.component';
import { RulebookSettingsComponent } from './rulebook-settings/rulebook-settings.component';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import { NgSelectModule } from '@ng-select/ng-select';
import { TooltipModule } from 'primeng/tooltip';
import { ReportingSettingsComponent } from './reporting-settings/reporting-settings.component';
import { ThemeSettingsComponent } from './theme-settings/theme-settings.component';
import {ButtonModule} from 'primeng/button';
import { ProjectNameListComponent } from './project-name-list/project-name-list.component';
import { LucideAngularModule, Plus, Check, SaveAll, X} from 'lucide-angular';
import { AddDropdownOptionComponent } from './add-dropdown-option/add-dropdown-option.component';
import { MatSelectModule } from '@angular/material/select';


@NgModule({
  declarations: [
    ManageRolesComponent,
    UserManagementLandingComponent,
    UserManagerComponent,
    CreateUsersComponent,
    UserRegulatorDialogComponent,
    AddRoleDialogComponent,
    FileUploadDialogComponent,
    AuditTrailComponent,
    ManagePlanTypeComponent,
    ManagePubTypeComponent,
    ImpactAssessmentSettingsComponent,
    RulebookSettingsComponent,
    ReportingSettingsComponent,
    ThemeSettingsComponent,
    ProjectNameListComponent,
    AddDropdownOptionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    AlertModule.forRoot(),
    RouterModule.forChild(UserManagementRoutes),
    SharedUIModule,
    DistributedUIModule,
    MatDialogModule,
    MatButtonModule,
    BsDropdownModule,
    ScrollingModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    NgSelectModule,
    MatChipsModule,
    MatIconModule,
    TooltipModule,
    ButtonModule,
    LucideAngularModule.pick({Plus, Check, SaveAll,X}),
    MatSelectModule
  ],
  providers: [
    AnalyticsService,
    SessionService,
    UserManagementService,
    CommonService
  ],
  entryComponents: [
    UserRegulatorDialogComponent,
    AddRoleDialogComponent,
    FileUploadDialogComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class UserManagementModule { }
